require('./loanFilter.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { getLanguage } = require('core/i18n').i18n;
const { formatCurrency } = require('utilities/currencyHelper');
const OKModal = require('components/commons/OKModal/OKModal');
const DateFilter = require('components/commons/dateFilter/dateFilter');
const { AmountFilter } = require('commonsComponents/amountFilter');
//@constants
const { EURO_SYMBOL } = require('constants/index');
const { AMOUNT_FILTER_LABEL, AMOUNT_FILTER_GREATER_THAN, AMOUNT_FILTER_LOWER_THAN } = require('constants/commonsComponents');
//@utilities
const { recordLinkV2 } = require('utilities/tagging');
//@analytics
const { commonCatalogueFilters, commonFilterAnalyticsId } = require('utilities/taggingCommonCatalogue');

class LoanFilter extends React.Component {
    constructor(props) {
        super(props);

        const { immFilter } = props;
        const immDate = immFilter.get('date');

        this.state = {
            dateSelected: immDate.get('selected'),
            dateFrom: immDate.get('from'),
            dateTo: immDate.get('to'),
            amountFrom: immFilter.getIn(['amount', 'from', 'amount']),
            amountTo: immFilter.getIn(['amount', 'to', 'amount'])
        };

        this.shouldComponentUpdate =
            PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChangeAmountMin = this.handleChangeAmountMin.bind(this);
        this.handleChangeAmountMax = this.handleChangeAmountMax.bind(this);
        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
        this.handleCancelModal = this.handleCancelModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    componentDidMount() {
        recordLinkV2(
            commonCatalogueFilters[commonFilterAnalyticsId.OPEN_MODAL]()
        );
    }

    handleChangeAmountMax(amountTo) {
        this.setState({
            amountTo,
        });
    }

    handleChangeAmountMin(amountFrom) {
        this.setState({
            amountFrom,
        });
    }

    onFocusMaxAmount() {
        recordLinkV2(
            commonCatalogueFilters[commonFilterAnalyticsId.INPUT_TO]()
        );
    }

    onFocusMinAmount() {
        recordLinkV2(
            commonCatalogueFilters[commonFilterAnalyticsId.INPUT_FROM]()
        );
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo,
        });
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom,
        });
    }

    handleChangeDateSelected(dateSelected) {
        recordLinkV2(
            commonCatalogueFilters[commonFilterAnalyticsId.SELECT_DATE](
                dateSelected
            )
        );
        this.setState({
            dateSelected,
        });
    }

    handleFormSubmit(event) {
        event.preventDefault();
        recordLinkV2(
            commonCatalogueFilters[commonFilterAnalyticsId.APPLY_BUTTON]()
        );

        const { onSetFilters, onCloseClick } = this.props;
        const { dateFrom, dateTo, dateSelected, amountFrom, amountTo } = this.state;

        onSetFilters({
            date: {
                selected: dateSelected,
                from: dateFrom,
                to: dateTo,
            },
            amount: {
                from: {
                    amount: amountFrom,
                },
                to: {
                    amount: amountTo,
                },
            },
        });

        onCloseClick();
    }

    handleCancelModal() {
        const { onCloseClick } = this.props;
        recordLinkV2(
            commonCatalogueFilters[commonFilterAnalyticsId.CANCEL_BUTTON]()
        );
        onCloseClick();
    }

    handleCloseModal() {
        const { onCloseClick } = this.props;
        recordLinkV2(
            commonCatalogueFilters[commonFilterAnalyticsId.CLOSE_MODAL]()
        );
        onCloseClick();
    }

    render() {
        const { immFilter, amountLabelName, dateLabelTitle } = this.props;
        const { amountFrom, amountTo } = this.state;
        const modalContent = (
            <section role="modalContainer" className="loan-filter">
                <div>
                    <fieldset>
                        <DateFilter
                            immFilter={immFilter.get('date')}
                            onChangeMin={this.handleChangeDateMin}
                            onChangeMax={this.handleChangeDateMax}
                            onChangeSelected={this.handleChangeDateSelected}
                            dateLabelTitle={
                                dateLabelTitle ? dateLabelTitle : null
                            }
                        />
                    </fieldset>
                    <fieldset>
                        <AmountFilter
                            immFilter={immFilter}
                            onChangeMin={this.handleChangeAmountMin}
                            onChangeMax={this.handleChangeAmountMax}
                            handleOnFocusMaxAmount={this.onFocusMaxAmount}
                            handleOnFocusMinAmount={this.onFocusMinAmount}
                            fromValue={amountFrom}
                            toValue={amountTo}
                            currencySymbol={formatCurrency(EURO_SYMBOL)}
                            amountLabel={
                                amountLabelName
                                    ? amountLabelName
                                    : AMOUNT_FILTER_LABEL
                            }
                            greaterThan={AMOUNT_FILTER_GREATER_THAN}
                            lowerThan={AMOUNT_FILTER_LOWER_THAN}
                            language={getLanguage()}
                        />
                    </fieldset>
                </div>
            </section>
        );

        return (
            <OKModal
                content={modalContent}
                footerType="navigation"
                isOpen={true}
                onCloseCallback={this.handleCloseModal}
                onPrimaryButtonClick={this.handleFormSubmit}
                onSecondaryButtonClick={this.handleCancelModal}
                primaryButtonText="loansMovementsFilters-apply"
                secondaryButtonText="loansMovementsFilters-cancel"
                title="loansMovementsFilters-loansMovementsFilters_title"
                type="filter"
            />
        );
    }
}

LoanFilter.propTypes = {
    immFilter: PropTypes.object.isRequired,
    onSetFilters: PropTypes.func.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    amountLabelName: PropTypes.string,
    dateLabelTitle: PropTypes.string,
};

module.exports = LoanFilter;
